var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/SelectFollowsTabsContainer/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Tabs } from "@mlb/react-patterns/dist/components/Tabs/tabs";
import React from "react";
import ListContainer, { ListContainerTypes } from "../ListContainer";
import { SelectFollowsTabsContainerContainer } from "./styles";
var ComponentKey = "select-follows-tabs-container";
var SelectFollowsTabsContainer = function SelectFollowsTabsContainer(_ref) {
  var className = _ref.className,
    containerProps = _ref.containerProps,
    favoriteId = _ref.favoriteId,
    items = _ref.items,
    onFilterClick = _ref.onFilterClick,
    onFollowClick = _ref.onFollowClick,
    _ref$onTabClick = _ref.onTabClick,
    onTabClick = _ref$onTabClick === void 0 ? function () {} : _ref$onTabClick,
    _ref$playersTabName = _ref.playersTabName,
    playersTabName = _ref$playersTabName === void 0 ? "Players" : _ref$playersTabName,
    _ref$teamsTabName = _ref.teamsTabName,
    teamsTabName = _ref$teamsTabName === void 0 ? "Teams" : _ref$teamsTabName;
  var list = [{
    children: /*#__PURE__*/React.createElement(ListContainer, {
      favoriteId: favoriteId,
      items: items,
      onClick: onFilterClick,
      type: ListContainerTypes.FILTER,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 9
      }
    }),
    handlers: {
      onClick: function onClick(e) {
        return onTabClick(e, playersTabName);
      }
    },
    name: playersTabName
  }, {
    children: /*#__PURE__*/React.createElement(ListContainer, {
      favoriteId: favoriteId,
      items: items,
      onClick: onFollowClick,
      type: ListContainerTypes.FOLLOW,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 9
      }
    }),
    handlers: {
      onClick: function onClick(e) {
        return onTabClick(e, teamsTabName);
      }
    },
    name: teamsTabName
  }];
  return /*#__PURE__*/React.createElement(SelectFollowsTabsContainerContainer, _extends({
    className: className,
    "data-testid": ComponentKey
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Tabs, {
    initialActiveTab: list[0].name,
    list: list,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }));
};
export default /*#__PURE__*/React.memo(SelectFollowsTabsContainer);